import React from "react";
import { Truck, ShieldCheck, BadgeCheck, MapPin, RotateCcw } from "lucide-react";

const items = [
  { icon: Truck, text: "Livraison offerte dès 60€ FR · 160€ Intl." },
  { icon: ShieldCheck, text: "Paiement 100% sécurisé" },
  { icon: BadgeCheck, text: "Produits authentiques" },
  { icon: MapPin, text: "Expédié de France · 48–72h" },
  { icon: RotateCcw, text: "Retours sous 14 jours" },
];

const ReassuranceBar = () => {
  return (
    <div
      data-testid="reassurance-bar"
      className="w-full bg-[color:var(--gold)]/[0.06] border-b border-[color:var(--gold)]/25 backdrop-blur-md"
    >
      {/* Desktop: grid inline */}
      <div className="hidden md:flex max-w-[1600px] mx-auto px-6 lg:px-12 items-center justify-between py-2.5 label-caps text-[10px] text-white/85">
        {items.map((it, i) => {
          const Icon = it.icon;
          return (
            <div key={i} className="flex items-center gap-2.5">
              <Icon size={13} strokeWidth={1.5} className="text-[color:var(--gold)]" />
              <span>{it.text}</span>
            </div>
          );
        })}
      </div>
      {/* Mobile: marquee */}
      <div className="md:hidden overflow-hidden py-2">
        <div className="marquee-track flex gap-10 whitespace-nowrap label-caps text-[10px] text-white/85">
          {[...items, ...items].map((it, i) => {
            const Icon = it.icon;
            return (
              <div key={i} className="flex items-center gap-2 shrink-0">
                <Icon size={12} strokeWidth={1.5} className="text-[color:var(--gold)]" />
                <span>{it.text}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ReassuranceBar;
